interface Coordinates {
  left: number;
  top: number;
  width: number;
  height: number;
}

export const cropBlob = async (blob: Blob, crop: Coordinates) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) return blob;

  const img = new Image();
  img.src = URL.createObjectURL(blob);

  await img.decode();

  canvas.width = crop.width;
  canvas.height = crop.height;

  ctx.drawImage(img, crop.left, crop.top, crop.width, crop.height, 0, 0, crop.width, crop.height);

  return await (await fetch(canvas.toDataURL(), {cache: 'no-cache'})).blob();
};
